import { render, staticRenderFns } from "./SignupClient.vue?vue&type=template&id=595ab9b5&scoped=true"
import script from "./SignupClient.vue?vue&type=script&lang=js"
export * from "./SignupClient.vue?vue&type=script&lang=js"
import style0 from "./SignupClient.vue?vue&type=style&index=0&id=595ab9b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595ab9b5",
  null
  
)

export default component.exports